var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTableWithGroups',{ref:"dataTableWithGroups",attrs:{"title":_vm.title,"configuration":_vm.configuration,"dataTableItems":_vm.items,"items-key":_vm.itemsKey,"trackerDTO":_vm.trackerDTO,"featureId":_vm.featureId,"footer":_vm.footer}})
}
var staticRenderFns = []

export { render, staticRenderFns }